import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4H2v16h20V4zm-2 14H4v-6h16v6zm0-10H4V6h16v2z"
}), 'PaymentSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PaymentSharp.js
// module id = 5239
// module chunks = 2